module.exports = __webpack_public_path__ + "static/media/cq_stampa.e7bad3dc.svg";